module.exports = __webpack_public_path__ + "static/media/S40.de0f854b.png";